module.exports = __webpack_public_path__ + "static/media/advantage-cswap-x-midnight-1.28841821.png";